import script from "./SupervisorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupervisorPage.vue?vue&type=script&lang=ts&setup=true"

import "./SupervisorPage.vue?vue&type=style&index=0&id=16cfe194&lang=sass"

const __exports__ = script;

export default __exports__